module.exports = __webpack_public_path__ + "static/3.902f90c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BSc/3.png
// module id = 821
// module chunks = 93830084423213 241891719824365